import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconSellerType = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M12 10C9.79 10 8 8.21 8 6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6C16 8.21 14.21 10 12 10ZM12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4Z" }),
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M19 22H5V14.72L5.14 14.48C6.49 12.23 8.93 11 12 11C15.07 11 17.5 12.24 18.86 14.48L19 14.72V22ZM7 20H17V15.29C15.99 13.81 14.23 13 12 13C9.77 13 8.01 13.81 7 15.29V20Z" }))));
};
